export default __webpack_public_path__ + "static/media/30.4618e612.jpeg";